import React from 'react';
import PendingChanges from './PendingChanges';

const StudioSidebar = ({
  pages,
  splits,
  selectedPageIndex,
  aiSuggestions,
  onSplitAtSelected,
  onDeletePage,
  onRotatePage,
  onAcceptAllSuggestions,
  onUndo,
  canUndo,
}) => {
  const selectedPage = pages[selectedPageIndex];
  const hasAISuggestions = aiSuggestions && aiSuggestions.length > 0;

  const handleAcceptSuggestion = (suggestion) => {
    if (suggestion.onAccept) {
      suggestion.onAccept();
    }
  };

  return (
    <div className="ds-sidebar">
      <div className="ds-sidebar-section">
        <div className="ds-sidebar-section-title">Operations</div>
        <div className="ds-sidebar-operations">
          <button
            className="ds-sidebar-btn"
            onClick={onSplitAtSelected}
            disabled={selectedPageIndex === 0}
            title="Split document before selected page (S)"
          >
            <span className="ds-sidebar-btn-icon">✂</span>
            <span className="ds-sidebar-btn-label">Split Here</span>
          </button>
          <button
            className="ds-sidebar-btn"
            onClick={() => onDeletePage(selectedPageIndex)}
            disabled={!selectedPage || selectedPage.deleted}
            title="Delete selected page (Delete)"
          >
            <span className="ds-sidebar-btn-icon">🗑</span>
            <span className="ds-sidebar-btn-label">Delete Page</span>
          </button>
          <button
            className="ds-sidebar-btn"
            onClick={() => onRotatePage(selectedPageIndex)}
            disabled={!selectedPage}
            title="Rotate selected page 90° clockwise (R)"
          >
            <span className="ds-sidebar-btn-icon">↻</span>
            <span className="ds-sidebar-btn-label">Rotate 90°</span>
          </button>
        </div>
      </div>

      {hasAISuggestions && (
        <div className="ds-sidebar-section">
          <div className="ds-sidebar-section-title">
            AI Suggestions
            <span className="ds-sidebar-ai-badge">Claude</span>
          </div>
          <div className="ds-sidebar-suggestions">
            {aiSuggestions.map((suggestion, idx) => (
              <div key={idx} className="ds-sidebar-suggestion">
                <div className="ds-sidebar-suggestion-header">
                  <span className="ds-sidebar-suggestion-icon">◆</span>
                  <span className="ds-sidebar-suggestion-text">
                    Split at page {suggestion.beforePageIndex}
                  </span>
                  <span className="ds-sidebar-suggestion-confidence">
                    {Math.round(suggestion.confidence * 100)}%
                  </span>
                </div>
                {suggestion.reason && (
                  <div className="ds-sidebar-suggestion-reason">
                    {suggestion.reason}
                  </div>
                )}
              </div>
            ))}
            <button
              className="ds-sidebar-accept-all"
              onClick={onAcceptAllSuggestions}
            >
              Accept All Suggestions
            </button>
          </div>
        </div>
      )}

      <div className="ds-sidebar-section">
        <PendingChanges
          pages={pages}
          splits={splits}
          onUndo={onUndo}
          canUndo={canUndo}
        />
      </div>
    </div>
  );
};

export default StudioSidebar;
